import React from 'react';

import useStyles from './useStyles';

export const FormGroup = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.formGroup}>{children}</div>;
};
